import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Resetpassword from "./pages/Resetpassword";
import Forgotpassword from "./pages/Forgotpassword";
import MainLayout from "./components/MainLayout";
import Enquiries from "./pages/Enquiries";
import Bloglist from "./pages/Bloglist";
import Blogcatlist from "./pages/Blogcatlist";
import Orders from "./pages/Orders";
import Customers from "./pages/Customers";
import ViewCust from "./pages/ViewCustomer";
import Students from "./pages/Students";
import Schools from "./pages/Schools";
import StateCluster from "./pages/StateCluster";
import Addvtvc from "./pages/Addvtvc";
import Addschool from "./pages/Addschool";
import Addstudent from "./pages/Addstudent";
import Addstate from "./pages/Addstate";
import Attendance from "./pages/Attendance_main";
import AttendanceDetail from "./pages/Attendance";
import MouStatus from "./pages/MouStatus";
import Curriculam from "./pages/Curriculam"
import Trainningschdule from "./pages/Trainningschdule";
import Guestlecture from "./pages/Guestlecture";
import Industrialvisit from "./pages/Industrialvisit";
import AssesmentReport from "./pages/Assesmentreport";
import PlacementReport from "./pages/Placementreport";
import Colorlist from "./pages/Colotlist";
import Categorylist from "./pages/Categorylist";
import Brandlist from "./pages/Brandlist";
import Jobtradelist from "./pages/Jobtradelist";
import Sectorslist from "./pages/Sectorlist";
import Programlist from "./pages/Programlist";
import Payments from "./pages/Payments";
import Salary from "./pages/SalaryRecordData";
import Productlist from "./pages/Productlist";
import Addblog from "./pages/Addblog";
import Addblogcat from "./pages/Addcat";
import Addcolor from "./pages/Addcolor";
import Addcat from "./pages/Addcat";
import Addbrand from "./pages/Addbrand";
import Addjobtrade from "./pages/Addjobtrade";
import Addsectors from "./pages/Addsectors";
import Addprograms from "./pages/Addprograms";
import Addproduct from "./pages/Addproduct";
import Couponlist from "./pages/Couponlist";
import AddCoupon from "./pages/AddCoupon";
import ViewEnq from "./pages/ViewEnq";
import ViewOrder from "./pages/ViewOrder";
import VacantPosition from "./pages/VacantPosition";
import Addcurriculam from "./pages/Addcurriculam";
import Addbulkvt from "./pages/Addbulkvt";
import AddbulkSchool from "./pages/AddbulkSchool";
import VcPerformance from "./pages/VcPerformance";
import VCLeaderboard from "./pages/VCLeaderboard";
import TaskCompletion from "./pages/TaskCompletion";
import InvoiceReceipt from "./pages/InvoiceReceipt";
import SalaryPayment from "./pages/SalaryPayment"
import PaymentVsReceipt from "./pages/PaymentVsReceipt";
import MyProfile from "./pages/MyProfile";
import UserManagement from "./pages/UserManagement";

function App() {
  return (
    <Router>
      <Routes>
         {/* <ConnectionStatus /> */}
        <Route path="/" element={<Login />} />
        <Route path="/reset-password/:token" element={<Resetpassword />} />
        <Route path="/forgot-password" element={<Forgotpassword />} />
        <Route path="/admin" element={<MainLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="enquiries" element={<Enquiries />} />
          <Route path="enquiries/:id" element={<ViewEnq />} />
          <Route path="blog-list" element={<Bloglist />} />
          <Route path="blog" element={<Addblog />} />
          <Route path="blog/:id" element={<Addblog />} />
          <Route path="coupon-list" element={<Couponlist />} />
          <Route path="coupon" element={<AddCoupon />} />
          <Route path="coupon/:id" element={<AddCoupon />} />
          <Route path="blog-category-list" element={<Blogcatlist />} />
          <Route path="blog-category" element={<Addblogcat />} />
          <Route path="blog-category/:id" element={<Addblogcat />} />
          <Route path="orders" element={<Orders />} />
          <Route path="order/:id" element={<ViewOrder />} />
          <Route path="customers" element={<Customers />} />
          <Route path="customer/:id" element={<ViewCust />} />
          <Route path="students" element={<Students />} />
          <Route path="schools" element={<Schools />} />
          <Route path="statecluster" element={<StateCluster />} />
          <Route path="mou-status" element={<MouStatus />} />
          <Route path="vacant-position" element={<VacantPosition />} />
          <Route path="vtvc/:id" element={<Addvtvc />} />
          <Route path="vtvc" element={<Addvtvc />} />
          <Route path="add-curriculam" element={<Addcurriculam />} />
          <Route path="add-bulkvt" element={<Addbulkvt />} />
          <Route path="add-bulkschool" element={<AddbulkSchool />} />
          <Route path="add-state" element={<Addstate />} />
          <Route path="add-school" element={<Addschool />} />
          <Route path="add-student" element={<Addstudent />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="attendance-view/:id" element={<AttendanceDetail />} />
          <Route path="curriculam" element={<Curriculam />} />
          <Route path="trainning-schedule" element={<Trainningschdule />} />
          <Route path="guestlecture" element={<Guestlecture />} />
          <Route path="industrial-visits" element={<Industrialvisit />} />
          <Route path="assesment-report" element={<AssesmentReport />} />
          <Route path="placement-report" element={<PlacementReport />} />
          <Route path="list-color" element={<Colorlist />} />
          <Route path="color" element={<Addcolor />} />
          <Route path="color/:id" element={<Addcolor />} />
          <Route path="list-category" element={<Categorylist />} />
          <Route path="category" element={<Addcat />} />
          <Route path="category/:id" element={<Addcat />} />
          <Route path="list-class" element={<Brandlist />} />
          <Route path="list-jobtrade" element={<Jobtradelist />} />
          <Route path="list-sectors" element={<Sectorslist />} />
          <Route path="list-programs" element={<Programlist />} />
          <Route path="brand" element={<Addbrand />} />
          <Route path="brand/:id" element={<Addbrand />} />
          <Route path="jobtrade" element={<Addjobtrade />} />
          <Route path="jobtrade/:id" element={<Addjobtrade/>} />
          <Route path="sectors" element={<Addsectors />} />
          <Route path="sectors/:id" element={<Addsectors/>} />
          <Route path="programs" element={<Addprograms />} />
          <Route path="payments" element={<Payments />} />
          <Route path="salary-records" element={<Salary />} />
          <Route path="programs/:id" element={<Addprograms/>} />
          <Route path="list-product" element={<Productlist />} />
          <Route path="product" element={<Addproduct />} /> 
          <Route path="vc-performance" element={<VcPerformance />} />
          <Route path="vc-Leaderboard" element={<VCLeaderboard/>} />
          <Route path="task-completion" element={<TaskCompletion/>} />
          <Route path="invoice-receipt" element={<InvoiceReceipt/>} />
          <Route path="salary-payment" element={<SalaryPayment/>} />
          <Route path="payment-vs-receipt" element={<PaymentVsReceipt/>} />
          <Route path="my-profile" element={<MyProfile />} />
          <Route path="user-management" element={<UserManagement />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
